module.exports = __webpack_public_path__ + "static/media/radiation-alt.3deba543.svg";